module.exports = __webpack_public_path__ + "static/PAAB_logo_color_EN-1e0e9538ece5e2506f0572ba06cf13d7.png";